import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { BLOG_POSTS } from '../lib/pageContent';
import { BLOG_INDEX_PAGE } from '../constants/testIds';

const META_DESCRIPTION =
  'Guides and insights on buying bulk wholesale used tires, international container shipping, and tire grading standards from BulkUsedTires.com.';

export default function BlogIndexPage() {
  useDocumentMeta('Blog — Bulk Used Tire Export Guides | BulkUsedTires.com', META_DESCRIPTION);

  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <PageHero
        eyebrow="Blog"
        title="Bulk Tire Export Guides"
        description="Insights on wholesale pricing, grading standards and international shipping, from the team sourcing and exporting your containers."
      />
      <section data-testid={BLOG_INDEX_PAGE.section} className="py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 grid grid-cols-1 gap-6">
          {BLOG_POSTS.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              data-testid={BLOG_INDEX_PAGE.postCard(post.slug)}
              className="group rounded-2xl border border-brand-border bg-brand-surface p-7 sm:p-9 hover:border-brand-orange/60 transition-colors"
            >
              <p className="font-mono text-xs uppercase tracking-widest text-brand-amber">
                {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} &middot; {post.readTime}
              </p>
              <h2 className="mt-3 font-display font-bold uppercase text-2xl sm:text-3xl text-brand-text group-hover:text-brand-orange transition-colors">
                {post.title}
              </h2>
              <p className="mt-3 text-brand-muted text-sm sm:text-base leading-relaxed">{post.excerpt}</p>
              <span className="mt-5 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-brand-orange">
                Read Article <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
